<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'

import { AppHeader, SuccessBadge } from '@collector/shared-ui'
import {
  LiveEventInfo,
  LiveEventScouts,
  LivematchProDemoButton,
  StatsLevelSummary,
} from '@collector/shared-ui-domain'
import {
  useCompetition,
  useEvent,
  useEventScouts,
  useParticipants,
  useSeason,
} from '@desktop/views/Relation/composables'
import { injectEventInfoConfig } from '@desktop/views/Relation/Sports/provide-inject'

import EventInfoButton from './EventInfoButton/EventInfoButton.vue'
import LogoutButton from './LogoutButton.vue'
import NotificationsButton from './Notifications/NotificationsButton.vue'
import RelationButtons from './RelationButtons/RelationButtons.vue'
import ResetEventButton from './ResetEventButton.vue'
import { provideSuccessBadge } from './successBadge'

// TODO(composable-refactor): when useEvent, useCompetition, useSeason, useParticipants
// move out of desktop, delete prop wiring below for LiveEventInfo
// (areaName, shortName, stageName, homeName, awayName) and StatsLevelSummary
// (seasonStatsLevel, eventStatsLevel).

const { event } = useEvent()
const { competition } = useCompetition()
const { season } = useSeason()
const { homeParticipant, awayParticipant } = useParticipants()
const { eventScouts } = useEventScouts()
const eventInfoConfig = injectEventInfoConfig()

if (eventInfoConfig) {
  const successBadge = useTemplateRef('successBadge')
  provideSuccessBadge({ showSuccessBadge: () => successBadge.value?.show() })
}

const shouldDisplayResetEventButton = computed(() =>
  event.value.start_date.includes('1900'),
)
</script>

<template>
  <AppHeader>
    <LiveEventInfo
      :areaName="competition.area_name"
      :shortName="competition.short_name"
      :stageName="competition.season.stage.name"
      :homeName="homeParticipant?.short_name ?? ''"
      :awayName="awayParticipant?.short_name ?? ''"
    />
    <template #actions>
      <StatsLevelSummary
        :seasonStatsLevel="season.stats_lvl"
        :eventStatsLevel="event.event_stats_lvl"
      />
      <ResetEventButton v-if="shouldDisplayResetEventButton" />
      <LivematchProDemoButton :eventId="event.id" />
      <LogoutButton />
    </template>

    <template #toolbar>
      <NotificationsButton />
      <LiveEventScouts :eventScouts />
      <template v-if="eventInfoConfig">
        <EventInfoButton />
        <SuccessBadge
          ref="successBadge"
          class="z-10 ml-auto flex items-center pr-4"
          title="Event info updated successfully"
        >
          Saved
        </SuccessBadge>
      </template>

      <RelationButtons />
    </template>
  </AppHeader>
</template>
